import { DEFAULT_TOTAL_RECORDS } from "utils/constants";
import zoneLocalStorageId from "utils/zone";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchFranchise = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );
  let params = {
    limit,
    page_no,
    zone_id: zoneLocalStorageId(),
    ...filter,
  };

  if (f_is_franchise_employee === 1) {
    params = {
      ...params,
      f_is_franchise_employee,
      f_franchise_id,
      f_is_super_franchise,
    };
  }
  return axiosInstance.get(EndPoints.Franchise.LIST, {
    params,
  });
};

export const fetchChildFranchise = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );

  let { is_active, list_all_child_franchise, franchise_id } = filter;

  let params = {
    limit: 0,
    // page_no,
    zone_id: zoneLocalStorageId(),
    is_active,
    list_all_child_franchise,
    franchise_id,
  };

  if (f_is_franchise_employee === 1) {
    params = {
      ...params,
      f_is_franchise_employee,
      f_franchise_id,
      f_is_super_franchise,
    };
  }
  return axiosInstance.get(EndPoints.Franchise.LIST, {
    params,
  });
};

export const fetchFranchiseCopyRatesLog = (id) => {
  return axiosInstance.get(`${EndPoints.Franchise.COPY_RATES_LOG_LIST}/${id}`);
};

export const createFranchise = (payload) => {
  return axiosInstance.post(EndPoints.Franchise.CREATE, payload);
};

export const updateFranchise = (payload) => {
  return axiosInstance.put(EndPoints.Franchise.UPDATE, payload);
};

export const activeFranchise = (id) => {
  return axiosInstance.put(`${EndPoints.Franchise.ACTIVE}/?franchise_id=${id}`);
};

export const deleteFranchise = (payload) => {
  const url = EndPoints.Franchise.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const fetchFranchiseUsername = (payload) => {
  return axiosInstance.get(EndPoints.Franchise.EXISTS_USERNAME, {
    params: {
      ...payload,
      zone_id,
    },
  });
};

export const fetchFranchiseById = (id) => {
  return axiosInstance.get(`${EndPoints.Franchise.LIST_BY_ID}/${id}`);
};

export const downloadFranchiseCSV = () => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );
  return axiosInstance.put(
    `${
      EndPoints.Franchise.DOWNLOAD_CSV
    }?zone_id=${zoneLocalStorageId()}&f_is_franchise_employee=${f_is_franchise_employee}&f_franchise_id=${f_franchise_id}&f_is_super_franchise=${f_is_super_franchise}`,
    {},
    {
      responseType: "blob",
    }
  );
};

export const allotBarcodes = (payload) => {
  const { franchiseId, barcodeNumber } = payload;
  return axiosInstance.post(
    EndPoints.Franchise.ALLOT_BARCODE,
    {},
    {
      params: {
        franchise_id: franchiseId,
        num_barcode: barcodeNumber,
      },
    }
  );
};
